import { useQuery } from 'react-query';
import { api } from 'api/api';

export const useGetLeagues = () =>
  useQuery({
    queryKey: ['getLeagues'],
    queryFn: () => api.leagues.getLeagues(),
  });
